import Vue from 'vue';
export const Event = new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/event-bus.js